import { render, staticRenderFns } from "./orderServicerTodealNew.vue?vue&type=template&id=632a8650&"
import script from "./orderServicerTodealNew.vue?vue&type=script&lang=ts&"
export * from "./orderServicerTodealNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports